import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  URL_SECURE_DOCTOR_CDSS_PATIENTS,
  URL_SECURE_USER_DASHBOARD
} from '_constants/urls';

function Home(props = {}) {
  const { loginUrl, role } = props;

  if (role === 'ROLE_DOCTOR') {
    window.location.href = URL_SECURE_DOCTOR_CDSS_PATIENTS;
  } else if (role === 'ROLE_PATIENT') {
    window.location.href = URL_SECURE_USER_DASHBOARD;
  } else {
    window.location.href = loginUrl;
  }

  return null;
}

Home.propTypes = {
  loginUrl: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired
};
Home.defaultProps = {
  loginUrl: ''
};

const mapStateToProps = state => {
  const role = get(state, 'profile.profileVO.profile.roles[0]') || '';

  return {
    role
  };
};

export default connect(
  mapStateToProps,
  null
)(Home);
